export default {
  contacts: "contacts",
  groups: "groups",
};
